/* eslint-disable no-restricted-imports */
import {Checkbox, RadioGroup, Typography} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import {styled} from '@mui/material/styles';
import {ReactNode} from 'react';

import CheckboxCheckedCCIcon from 'components/icons/checkboxChecked-cc.svg';
import CheckboxUncheckedCCIcon from 'components/icons/checkboxUnchecked-cc.svg';

import {Block, BlockProps} from 'modules/decisionsNext/components/BaseFilter/Dialog/components/Block';

const SRadioWrapper = styled('div')<{disabled?: boolean}>(({theme, disabled}) => ({
  svg: {
    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
  },
}));

const SDisabledWrapper = styled('div')(({theme}) => ({
  padding: theme.spacing(0, 4, 0, 4),
}));

const SCheckbox = styled(Checkbox)(() => ({
  '&&': {
    padding: 0,
  },
}));

export function CheckboxGroupBlock<T extends any>({
  label,
  helperText,
  options,
  value: checkedValues,
  onChange: onCheckedValuesChange,
  dataTestId,
  row,
  disabled,
  disabledMessage,
}: DataTestId &
  BlockProps & {
    options: {label: string; value: T}[];
    value: T[];
    onChange: (value: T[]) => void;
    row?: boolean;
    disabled?: boolean;
    disabledMessage?: ReactNode;
  }) {
  return (
    <Block label={label} helperText={helperText} dataTestId={dataTestId}>
      {disabled && disabledMessage !== null && (
        <SDisabledWrapper>
          <Typography variant='subtitle3' color='text.secondary'>
            {disabledMessage}
          </Typography>
        </SDisabledWrapper>
      )}

      <RadioGroup row={row}>
        {options.map(({label, value}) => (
          <SRadioWrapper key={label} disabled={disabled}>
            <FormControlLabel
              control={
                <SCheckbox
                  checkedIcon={<CheckboxCheckedCCIcon />}
                  icon={<CheckboxUncheckedCCIcon />}
                  disabled={disabled}
                  checked={checkedValues.includes(value)}
                  onChange={e => {
                    const checked = e.target.checked;
                    const newCheckedValues = checked
                      ? [...checkedValues, value]
                      : checkedValues.filter(checkedValue => checkedValue !== value);
                    onCheckedValuesChange(newCheckedValues);
                  }}
                  color='primary'
                />
              }
              label={
                <Typography variant='buttonSmall' color={disabled ? 'text.disabled' : 'text.primary'}>
                  {label}
                </Typography>
              }
              disabled={disabled}
              disableTypography
            />
          </SRadioWrapper>
        ))}
      </RadioGroup>
    </Block>
  );
}
